<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeForm"
    :title="rowInfo.id===''?'添加调度员':'编辑调度员'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录名" prop="userName">
              <el-input v-model="rowInfo.userName" placeholder="管理员姓名" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户密码" prop="password">
              <el-input type="password"  v-model="rowInfo.password" placeholder="用户密码" maxlength="50" style="width: 220px"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="rowInfo.phone" placeholder="电话" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="管理城市" prop="cityCodes">
              <el-select v-model="rowInfo.cityCodes" clearable  multiple filterable placeholder="请选择管理城市">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.codeItemId"
                  :label="item.codeName"
                  :value="item.codeItemId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addListpage } from  "@/api/sys/sysinfo"
import { citys } from '@/const/city.js'
export default {
  data() {
    let validateUserName = (rule, value, callback) => {
        let partern =/^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){4,19}$/;
        if (!partern.test(value)) return callback(new Error('请输入正确的用户名'))
        callback()
    }
    // 手机号
    let validatePhone = (rule, value, callback) => {
      let isNum = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !isNum.test(value)) {
        callback(new Error('请输入正确的电话'))
      }
      callback()
    }
    return {
      visible: false,
      formName: '新增',
      loading: false,
      cityOptions:citys,
      oldFormInfo:'',
      rowInfo: {
        id: '',
        userName: '',
        phone: '',
        password: '',
        cityCodes:[]
      },
      rules: {
        userName: [{ required: true, message: '必填:用户名', trigger: 'blur' },
          { validator: validateUserName, trigger: 'blur' }
        ],
        password: [{ required: true, message: '必填:密码', trigger: 'blur' }],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    init(rowInfo) {
      this.visible = true
      if(rowInfo){
        this.rowInfo = JSON.parse(JSON.stringify(rowInfo));
        this.oldFormInfo = JSON.parse(JSON.stringify(rowInfo));
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let submitForm = JSON.parse(JSON.stringify(this.rowInfo));
          if(this.oldFormInfo){
            if(this.oldFormInfo.password==submitForm.password){
              submitForm.password = '';
            }
          }
          addListpage(submitForm).then((res) => {
              // 在store中改变修改的值
              if (this.rowInfo.id) {
                this.$message.success("编辑成功")
              } else {
                this.$message.success("添加成功")
              }
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
             this.closeForm()
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id: '',
        userName: '',
        phone: '',
        password: '',
        cityCodes:[]
      }
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .avatar-uploader .el-upload{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }
</style>
